import { Routes, Route, useLocation } from "react-router-dom";
import NotFound from "pages/NotFound";
import AllPages from "pages/AllPages";
import Blog from "pages/Blog";
import Article from "pages/SingleArticle";
import CustomerMessage from "pages/CustomerMessage";
import CustomerLayout from "components/layout/CustomerLayout";
import { useContext, useEffect } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import Profile from "components/profile/Profile";
import CustomerOrders from "pages/CustomerOrders";
import AdminDashboard from "pages/AdminDashboard";
import AdminLayout from "components/layout/AdminLayout";
import UserManagement from "pages/User_Management";
import AdminOrders from "pages/AdminOrder";
import GroupShoppingList from "pages/GroupShoppingList";
import ManagmentStore from "pages/ManagementStore";
import FinancialDepartment from "../components/Transaction/Transactions";
import CreditCardManagement from "pages/CreditCardManagement";
import HashtagManagement from "pages/HashtagManagement";

import AdminProduct from "pages/AdminProduct.jsx";

import { FactorList } from "pages/FactorList";
import PayPage from "pages/PayPage";

// import ShowCase from "pages/ShowCase";
import Home from "pages/Home";
import ShowCase from "pages/ShowCase";
import AdminFinancial from "pages/AdminFinancial";
import SingleProduct from "pages/SingleProduct";

import SingleProductRound from "pages/SingleProductRound";

import NewHome from "components/Home/NewHome";
import { CartItemsProvider } from "context/CardItems";
import ReactTooltip from "react-tooltip";
import { useParams } from "react-router-dom";
import GMlogo from "../assets/images/sitelogo.svg";

export default function AllRoutes() {
  const auth = useContext(WithAuthentication);
  // console.log(auth, "auth");

  return (
    <Routes>
      <Route path="all-pages" element={<AllPages />} />
      {/* <Route path="home" element={<Home />} /> */}
      <Route path="/shop/:businessId" element={<ShowCase logo={GMlogo} />} />
      <Route path="blog" element={<Blog />} />
      <Route path="article/:articleId" element={<Article />} />
      <Route path="productOld/:productIdx" element={<SingleProduct />} />
      <Route path="/" element={<NewHome />} />
      <Route path="/payment" element={<PayPage />} />
      <Route
        path="product/:productId/:businessId/:productType"
        element={<SingleProductRound logo={GMlogo} />}
      />
      <Route
        path="customer-panel/messages"
        element={
          auth.userInfo.userType == 1 && (
            <CustomerLayout>
              <CustomerMessage logo={GMlogo} />
            </CustomerLayout>
          )
        }
      />
      <Route
        path="customer-panel/financial-department"
        element={
          auth.userInfo.userType == 1 && (
            <CustomerLayout>
              <FinancialDepartment type={1} logo={GMlogo} />
            </CustomerLayout>
          )
        }
      />

      <Route
        path="customer-panel/profile"
        element={
          auth.userInfo.userType == 1 && (
            <CustomerLayout>
              <Profile logo={GMlogo} />
            </CustomerLayout>
          )
        }
      />
      <Route
        path="customer-panel/orders"
        element={
          auth.userInfo.userType == 1 && (
            <CustomerLayout>
              <CustomerOrders logo={GMlogo} />
            </CustomerLayout>
          )
        }
      />
      <Route
        path="shop/financial-department/:supplierId"
        element={
          auth.userInfo.userType == 2 && (
            <CustomerLayout>
              <FinancialDepartment type={2} logo={GMlogo} />
            </CustomerLayout>
          )
        }
      />
      {/* لیست خرید گروهی */}
      <Route
        path="shop/GroupShoppingList/:supplierId/:stortype"
        element={
          auth.userInfo.userType == 2 && (
            <AdminLayout>
              <GroupShoppingList logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>
      <Route
        path="shop/orders/:supplierId"
        element={
          auth.userInfo.userType == 2 && (
            <AdminLayout>
              <AdminOrders typeLogin={"adminShop"} logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>

      <Route
        path="admin-panel/dashboard"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <AdminDashboard logo={GMlogo} />
            </AdminLayout>
          )
        }
      />
      {/* <Route
        path="admin-panel/financial"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <AdminFinancial />
            </AdminLayout>
          )
        }
      ></Route> */}
      <Route
        path="admin-panel/financial-department"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <FinancialDepartment type={0} logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>

      <Route
        path="admin-panel/user-management"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <UserManagement logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>
      <Route
        path="admin-panel/orders"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <AdminOrders logo={GMlogo} typeLogin={"superAdmin"} />
            </AdminLayout>
          )
        }
      ></Route>
      {/* مدیریت کارتها بانکی */}
      <Route
        path="admin-panel/credit-card-management"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <CreditCardManagement logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>
      {/* مدیریت دسته بندی ها */}
      <Route
        path="admin-panel/HashtagManagement"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <HashtagManagement logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>
      {/* لیست محصولات */}
      <Route
        path="admin-panel/products"
        element={
          (auth.userInfo.userType == 0 || auth.userInfo.userType == 3) && (
            <AdminLayout>
              <AdminProduct logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>

      {/* لیست خرید گروهی */}
      <Route
        path="admin-panel/GroupShoppingList"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <GroupShoppingList logo={GMlogo} type="superAdmin" />
            </AdminLayout>
          )
        }
      ></Route>

      {/* مدیریت فروشگاه */}
      <Route
        path="admin-panel/ManagmentStore"
        element={
          auth.userInfo.userType == 0 && (
            <AdminLayout>
              <ManagmentStore logo={GMlogo} />
            </AdminLayout>
          )
        }
      ></Route>
      {/* لیست فاکتورها  */}
      <Route
        path="admin-panel/FactorList/:product_id/:business_id/:mtm/:userType"
        element={
          // auth.userInfo.userType == 0 && (
          <AdminLayout>
            <FactorList logo={GMlogo} />
          </AdminLayout>
          //)
        }
      ></Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
